import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import HistoryItem from '@/components/formats/RirekishoParts/HistoryItem.vue'
import AutoEducationalBackgrounds from '@/components/formats/RirekishoParts/AutoEducationalBackgrounds.vue'
import NewRirekishoResetDialog from '@/components/format-edit/new-rirekisho/NewRirekishoResetDialog.vue'
import gradeYearOptions from '@/utils/format-edit/newRirekishoGradeYearOptions.json'
import { useNewRirekishoFormatData } from '@/composables/format-edit/useNewRirekishoFormatData'
import { useNewRirekishoHistoriesApi } from '@/composables/format-edit/useNewRirekishoHistories'


export default /*#__PURE__*/_defineComponent({
  __name: 'NewRirekishoEduHistoryCard',
  props: {
    currentCardId: null,
    basicData: null,
    previewErrors: null
  },
  setup(__props: any) {

const descriptionMaxLength = 80



const formatData = useNewRirekishoFormatData()
const {
  activeHistoryItem,
  setEducationalBackgrounds,
  resetEducationalBackgrounds,
  addEducationalHistory,
  deleteEducationalHistory,
  moveEducationalHistory,
  activateHistoryItem
} = useNewRirekishoHistoriesApi()

const educationalResetVisible = ref(false)

return { __sfc: true,descriptionMaxLength, formatData, activeHistoryItem, setEducationalBackgrounds, resetEducationalBackgrounds, addEducationalHistory, deleteEducationalHistory, moveEducationalHistory, activateHistoryItem, educationalResetVisible, HistoryItem, AutoEducationalBackgrounds, NewRirekishoResetDialog, gradeYearOptions }
}

})